import { useState, useEffect } from "react";
import urlMapData from "@/app/data/urlMap.json";
import { UrlMapData } from "../interface/components";

const CACHE_KEY = "toyota_urlmap_cache";
const CACHE_VERSION = "1.0";

interface CacheData {
  version: string;
  timestamp: number;
  data: UrlMapData;
}

export function useUrlMapCache() {
  const [cachedData, setCachedData] = useState<UrlMapData | null>(null);

  useEffect(() => {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        const parsedCache = JSON.parse(cached) as CacheData;

        if (
          parsedCache.version === CACHE_VERSION &&
          Date.now() - parsedCache.timestamp < 24 * 60 * 60 * 1000
        ) {
          setCachedData(parsedCache.data);
          return;
        }
      } catch (error) {
        console.error("Erro ao ler cache:", error);
      }
    }

    const cacheData: CacheData = {
      version: CACHE_VERSION,
      timestamp: Date.now(),
      data: urlMapData as UrlMapData,
    };

    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
      setCachedData(urlMapData as UrlMapData);
    } catch (error) {
      if (error instanceof Error) {
        if (error.name === "QuotaExceededError") {
          try {
            localStorage.clear();
            localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
          } catch (e) {
            console.error("Erro de armazenamento:", e);
          }
        } else {
          console.error("Erro ao salvar cache:", error);
        }
      }
      setCachedData(urlMapData as UrlMapData);
    }
  }, []);

  return cachedData || (urlMapData as UrlMapData);
}
